<template>
    <v-layout row justify-center>
        <v-dialog v-model="dialog"
            :width="!isMobile ? '60%' : ''"
            :persistent="!isMobile"
            :fullscreen="isMobile"
            :hide-overlay="isMobile"
            :transition="isMobile ? 'dialog-bottom-transition':''">
            <v-card>
                <v-card-title>
                    <v-toolbar dark color="pink" card fixed>
                      <v-btn icon dark @click.native="dialog = false">
                        <v-icon>close</v-icon>
                      </v-btn>
                      <v-toolbar-title v-if="isEditMode">Editare {{entityName}}</v-toolbar-title>
                      <v-toolbar-title v-else>Adaugă {{entityName}}</v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-toolbar-items>
                        <v-btn dark flat
                            @click.native="onDialogSave()"
                            :loading="processing"
                            :disabled="processing">Save</v-btn>
                      </v-toolbar-items>
                    </v-toolbar>
                </v-card-title>
                  <v-container grid-list-md mt-4>
                      <v-layout wrap>
                          <v-flex xs12 v-if="errorMessageGeneric">
                              <v-alert :value="true" type="error">{{ errorMessageGeneric }}</v-alert>
                          </v-flex>
                          <v-flex v-for="(field, index) in fields" :key="index" xs12
                                  v-bind="{ [field.size]: true }">
                              <component :is="field.type"
                                v-if="shouldShow(field)"
                                :field="field"
                                :data="data"
                                :label="field.label"
                                :items="field.options"
                                item-value="id"
                                :item-text="field.itemText ? field.itemText : 'name'"
                                v-model="data[field.value]"
                                :persistent-hint="(isEditMode && field.inputType === 'password') || field.persistentHint"
                                :hint="(isEditMode && field.inputType === 'password') ? 'Completează acest câmp doar dacă vrei să schimbi parola': field.hint"
                                :error="!!errorMessages.length && field.value in errorMessages"
                                :error-messages="dialogErrorMessage(field.value)"
                                :errors="dialogErrorMessage(field.value)"
                                :type="field.inputType"
                                :box="field.box"
                                :apiEndpoint="field.apiEndpoint"
                                :required="field.required"/>
                          </v-flex>
                      </v-layout>
                  </v-container>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
import ActionSelector from './ActionSelector';
import DatePicker from './DatePicker';
import AutocompleteSelector from './AutocompleteSelector';
import ProductSearch from './ProductSearch';

export default {
  components: {
    ActionSelector,
    DatePicker,
    AutocompleteSelector,
    ProductSearch
  },

  props: ['fields', 'entityName', 'fieldValues', 'apiEndpoint', 'isMobile'],

  data() {
    return {
      errorMessages: [],
      errorMessageGeneric: null,
      data: { ...this.fieldValues },
      processing: false
    };
  },

  computed: {
    dialog: {
      get() {
        return !!this.fieldValues;
      },

      set(value) {
        this.$emit('status', value);
      }
    },

    isEditMode() {
      return this.data.id !== null;
    }
  },

  methods: {
    shouldShow(field) {
      if (field.hide) {
        if (field.hide(this.data)) {
          return true;
        } else {
          delete this.data[field.value];
          return false;
        }
      }
      return true;
    },

    dialogErrorMessage(field) {
      if (field in this.errorMessages) {
        return this.errorMessages[field];
      }
      return [];
    },

    onDialogSave() {
      this.errorMessages = [];
      this.processing = true;
      if (this.isEditMode) {
        // edit mode
        this.$store
          .dispatch(`${this.apiEndpoint}/EDIT`, this.data)
          .then(response => {
            this.processing = false;
            this.dialog = false;
          })
          .catch(error => {
            if (error.response.data.errors) {
              this.processing = false;
              this.errorMessages = error.response.data.errors;
            } else {
              this.processing = false;
              this.errorMessageGeneric = 'A apărut o eroare la salvare.';
            }
          });
      } else {
        // add mode
        this.$store
          .dispatch(`${this.apiEndpoint}/ADD`, this.data)
          .then(response => {
            this.processing = false;
            this.dialog = false;
            if (this.apiEndpoint === 'visits') {
              this.$router.push({ name: 'Visit', params: { id: response.data.id } });
            }
          })
          .catch(error => {
            if (error.response.data.errors) {
              this.processing = false;
              this.errorMessages = error.response.data.errors;
            } else {
              this.processing = false;
              this.errorMessageGeneric = 'A apărut o eroare la salvare.';
            }
          });
      }
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/EditDialog.vue